"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AphroditeBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const AutomaHandler_1 = require("../../automa/AutomaHandler");
const constants_1 = require("../../constants");
class AphroditeBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.APHRODITE_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU09',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Increase Venus 1 step. Gain 1 TR.', (eb) => {
                            eb.empty().startAction.venus(1).nbsp().tr(1);
                        });
                        ce.vSpace(Size_1.Size.MEDIUM);
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        game.automaBotVictoryPointsBreakdown.terraformRating += 2;
        if (game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE) {
            AutomaHandler_1.AutomaHandler.increaseVenusScale(game, 1);
            game.venusSilverCubeBonusMC = 0;
            const gotBonusTRFromVenusTrack = game.getVenusScaleLevel() === 16;
            if (gotBonusTRFromVenusTrack)
                game.automaBotVictoryPointsBreakdown.terraformRating++;
            const aphrodite = game.getPlayers().find((player) => player.isCorporation(CardName_1.CardName.APHRODITE));
            if (aphrodite !== undefined)
                aphrodite.megaCredits += gotBonusTRFromVenusTrack ? 4 : 2;
        }
        game.log('${0} action: Increase Venus 1 step and gain 1 TR', (b) => b.card(this));
        return undefined;
    }
}
exports.AphroditeBot = AphroditeBot;
//# sourceMappingURL=AphroditeBot.js.map